import { moduleNames } from 'pages/Stores/components/modules';
import { EVENT_MODES } from './constants';
import { createEventsConfig } from './EventsConfig';

export { EVENT_MODES } from './constants';

const defaultValues = {
  mode: EVENT_MODES.MANUAL,
  selectedItems: [],
};

export const createEventsModule = (useAvailableItems) => ({
  moduleName: moduleNames.EVENTS,
  nameTranslationPath: 'events.title',
  descriptionTranslationPath: 'events.moduleDescription',
  iconClassName: 'bi bi-calendar-event',
  defaultValues,
  isValid: (values) => values.mode === EVENT_MODES.UPCOMING || values.selectedItems?.length > 0,
  buildPayload: (values, { isEditMode = false } = {}) => ({
    ...(isEditMode || values.mode === EVENT_MODES.UPCOMING ? { mode: values.mode } : {}),
    ...(values.mode === EVENT_MODES.MANUAL
      ? { event_uids: values.selectedItems.map((event) => event.uid) }
      : {}),
  }),
  parseApiData: (module) => {
    const mode = module.mode === EVENT_MODES.UPCOMING ? EVENT_MODES.UPCOMING : EVENT_MODES.MANUAL;

    return {
      ...defaultValues,
      mode,
      selectedItems: mode === EVENT_MODES.MANUAL ? module.events || [] : [],
    };
  },
  ConfigComponent: createEventsConfig(useAvailableItems),
});
